import Countdown from 'react-countdown';
import { StatBar } from '../stats/StatBar';
import { Histogram } from '../stats/Histogram';
import { GameStats } from '../../lib/localStorage';
import { shareStatus } from '../../lib/share';
import { tomorrow } from '../../lib/words';
// import { BaseModal } from './BaseModal';
import Moment from 'moment-timezone';

import {
  STATISTICS_TITLE,
  RELATED_INFO,
  GUESS_DISTRIBUTION_TEXT,
  NEW_WORD_TEXT,
  SHARE_TEXT,
} from '../../constants/strings';

type Props = {
  isOpen: boolean;
  handleClose: () => void;
  guesses: string[];
  gameStats: GameStats;
  isGameLost: boolean;
  isGameWon: boolean;
  handleShare: () => void;
  isHardMode: boolean;
  Statistics: boolean;
  wordData: any;
  showTimer: any;
  date: any;
  puzzleHeadline: any;
  articleUrl: any;
};

const Result = ({
  isOpen,
  handleClose,
  guesses,
  gameStats,
  isGameLost,
  isGameWon,
  handleShare,
  isHardMode,
  Statistics,
  wordData,
  date,
  showTimer,
  puzzleHeadline,
  articleUrl,
}: Props) => {

  return (
    <div>
      <h4 className=" result-heading leading-6  text-gray-900 dark:text-gray-100">
        {RELATED_INFO}
      </h4>
      <div className="puzzle-headline p-two">
        <p>{puzzleHeadline}</p>
        <a href={articleUrl}>Read Article</a>
      </div>
      <h4 className=" result-heading leading-6  text-gray-900 dark:text-gray-100">
        {STATISTICS_TITLE}
      </h4>
      <StatBar gameStats={gameStats} />

      <h4 className="result-heading leading-6  text-gray-900 dark:text-gray-100">
        {GUESS_DISTRIBUTION_TEXT}
      </h4>

      <Histogram gameStats={gameStats} isGameWon={isGameWon} />

      {(isGameLost || isGameWon) && (
        <div>
          <div className="w-ful  dark:text-white" style={{marginTop:'15px'}}>
            <button
              style={{ fontSize: '16px!important' }}
              type="button"
              className="share-btn mt-2  w-full rounded-full  px-4 py-2  text-base font-medium  hover:bg-indigo-700  sm:text-sm"
              onClick={() => {
                shareStatus(
                  guesses,
                  isGameLost,
                  isHardMode,
                  wordData.url,
                  date,
                  wordData.shareable_link
                );
                handleShare();
              }}
            >
              {SHARE_TEXT}
            </button>
          </div>
          {/* <div className="bottom-counter">
            <h6>{NEW_WORD_TEXT}</h6>
            <Countdown
              className="result-heading  text-gray-900 dark:text-gray-100"
              date={tomorrow}
              daysInHours={true}
            />
          </div> */}
        </div>
      )}
    </div>
  );
};

export default Result;
